window.HMAPRejectionTemplatesSettingsForm = function ($scope, $alert, settingsFactory, brand) {
    var self = this;
    var formName = "hmap-rejection-templates-settings-form";
    var _protected = BaseForm.call(self, formName, $scope);

    var orginalData = {};
    self.isSaving = false;

    self.brandId = brand.id;
};
